jQuery(document).ready(function($) {

    var d = new Date();
    var n = d.toJSON();
    console.log(n);

	var discounturl = 'https://coupons.organicinfusions.com/access.php'; 
	var success_message = '';
	var error_message = '';
	
	//CHECK for DISCOUNT QUERYSTRING
	function getStringQ(str) {
		return str.split('=')[1];
	}
	var discQ = window.location.search;
	console.log('discQ = '+ discQ);
	if(discQ !== '') {
	    console.log('discQ is not empty');
		var codeQuery = getStringQ(discQ);
		checkDiscount(codeQuery, cartGTotal);
	} 

	function checkDiscount(a, c) {
	    
	    //CHECK DISCOUNT CODE AGAINST DISCOUNT URL
		$.ajax({
			type:"GET", 
			url: discounturl,
			dataType: "json",
			success: function(data) {
			    console.log('this is data:');
			    console.log(data);
				var disdata;
				$.each(data, function () {
					$.each(this, function() {
						disdata = this;
						//console.log(disdata);
						if(this['title'].toLowerCase() == codeValue) {
							discount_result = true;
							return false;
						} else
						{
							discount_result = false;
						}
					});
					process_discount(discount_result, disdata, cartTotalPrice);
				});
				//console.log(data);
			}, 
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(jqXHR, textStatus, errorThrown);
			}
		});
	    
		var codeValue = a;
		var cartTotalPrice = parseFloat(c);
		
		console.log('cart val = '+c);
		$('.coupon-error').css('display', 'none');
		$('.coupon-success').css('display', 'none');
		var discount_result = false;
		
		function process_discount(a,b,c) {
		    console.log('a = '+ a);
			if(a === true) {
				var discount_title,
					discount_value,
					discount_type,
					entitled_product_ids,
					entitled_variant_ids,
					min_amount,
					hasVariant,
					expdate;
				    console.log(b);
				$.each(b, function() {
					discount_title = b['title'];
					discount_value = b['value'];
					discount_type = b['value_type'];
					entitled_product_ids = b['entitled_product_ids'];
					entitled_variant_ids = b['entitled_variant_ids'];
					min = b['prerequisite_subtotal_range'];
					expdate = b['ends_at'];
				});
				
				var dismsg;
				var success_message;
				var ced;
				
				var d = new Date();
				var todaysdate = d.getTime();
				
				if(expdate != null) {
				    expdate = new Date(expdate);
				    ced = expdate.getTime();
				} else {
				    ced = 0;
				}
				
				//check if coupon code is expired
				if(Number(todaysdate) >= Number(ced) && Number(ced) != 0) {
				    dismsg = '';
				    success_message = '';
					error_message = "That coupon code is expired.";
					$('.coupon-error').css('display', 'block').text(error_message).delay(4000).fadeOut();
				} else {
				    //CHECK FOR PRODUCT REQUIREMENTS (IF THIS CODE REQUIRES A CERTAIN PRODUCT TO BE IN THE CART)
    				var hasProduct;
    				if($.isEmptyObject(entitled_product_ids)) {
    					hasProduct = false;
    				} else {
    					hasProduct = true;
    				}
    				
    				//CHECK FOR VARIANT REQUIREMENTS (IF THIS CODE REQUIRES A CERTAIN VARIANT TO BE IN THE CART)
    				if($.isEmptyObject(entitled_variant_ids)) {
    					hasVariant = false;
    				} else {
    					hasVariant = true;
    				}
    				console.log('has product: '+ hasProduct);
    				//console.log('has variant: '+ hasVariant);
    				
    				if(discount_type == 'fixed_amount') {
    					discount_value *= -1;
    					dismsg = 'A discount of $' + discount_value.toFixed(2) + ' has been applied. ';
    				} else {
    					discount_value *= -1;
    					dismsg = 'A discount of ' + discount_value + '% has been applied. ';
    				}
    				
    				var bogoPro;
    				var lookCode;
    				
    				function runValue(codeValue) {
    				    
    				    CartJS.updateItemQuantitiesById({
    				        37386215885: 0,
							2057121169434: 0,
							1845303476250: 0,
							37386216205: 0,
							2837623996442: 0,
							12422841892938: 0,
							2931554746394: 0,
							3133697818650: 0,
							3201667432474: 0,
							3327532728346: 0,
							3449653788698: 0,
							3526233718810: 0,
							3596793249818: 0,
							3600253255706: 0,
							3600979722266: 0,
							3604386054170: 0,
							3604634861594: 0,
							3604634894362: 0,
							3604635025434: 0,
							3604635058202: 0,
							3604635090970: 0,
							12074947510346: 0,
							12074956423242: 0,
							12074957668426: 0,
							12074957766730: 0,
							12074957832266: 0,
							12074957865034: 0,
							12110393573450: 0,
							12127264997450: 0,
							12127270240330: 0,
							12127276007498: 0,
							12127281610826: 0,
							12127284691018: 0,
							12127288361034: 0,
							2931568803866: 0,
							12374629384266: 0,
							12374638329930: 0,
							12374640754762: 0,
							2504392310810: 0,
							12470765912138: 0,
							12556439879754: 0,
							12569297649738: 0,
							12569301614666: 0,
							13613926940746: 0,
							13628784672842: 0,
							13634652766282: 0,
							15387976663114: 0,
							15387977908298: 0,
							15394983149642: 0,
							15859631325258: 0,
							16236971851850: 0,
							28028019081290: 0,
							28266036461642: 0,
							30172848848970: 0,
							30172864249930: 0,
							30172934373450: 0,
							30882776776778: 0,
							31350705324106: 0,
							31350729506890: 0,
							31350799695946: 0,
							31687693926474: 0,
							31687695040586: 0,
							31884970328138: 0,
							31884973604938: 0,
							32483185918026: 0,
							32518075744330: 0,
							31350729506890: 0,
    				    });
    				    
    				    //CHECK AGAINST SPECIFIC CODES
						if(codeValue == 'argan50') {
							CartJS.addItem(37386215885, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						//TEST CODE
						if(codeValue == 'defcon') {
							CartJS.addItem(2057121169434, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'freefrank') {
							CartJS.addItem(1845303476250, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'start300') {
							CartJS.addItem(37386216205, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lavpep') {
							CartJS.addItem(2837623996442, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == '3free') {
							CartJS.addItem(12422841892938, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'blackfriday') {
							CartJS.addItem(2931554746394, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						/*
						if(codeValue == 'thanks') {
							CartJS.addItem(2931568803866, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						*/
						if(codeValue == 'rosehip') {
							CartJS.addItem(3133697818650, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'giftbag') {
							CartJS.addItem(3201667432474, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'newyear') {
							CartJS.addItem(3327532728346, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'hydkit') {
							CartJS.addItem(3449653788698, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'myblends') {
							CartJS.addItem(3526233718810, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'vday') {
							CartJS.addItem(3596793249818, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'newdeal') {
							CartJS.addItem(3600253255706, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'turm17') {
							CartJS.addItem(3600979722266, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'eob') {
							CartJS.addItem(3604386054170, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'spring') {
							CartJS.addItem(3604634861594, 1); //FREE Spring Essentials
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'myskin') {
							CartJS.addItem(3604634894362, 1); //FREE Ultimate Skincare Bundle
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == '3roll') {
							CartJS.addItem(3604635025434, 1); //FREE Roll-On Trio
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'ds18') {
							CartJS.addItem(3604635058202, 1); //FREE Diffuser Starter Set
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'fm18') {
							CartJS.addItem(3604635090970, 1); //FREE Frankincense & Myrrh Essential Oils
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'wkit') {
							CartJS.addItem(12074947510346, 1); //Free Women's Care Kit
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'wellness') {
							CartJS.addItem(12074956423242, 1); //FREE Wellness Must-Haves (5 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'sleep') {
							CartJS.addItem(12074957668426, 1); //FREE Tranquility & Sleep Well Bundle (3 Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'roseheart') {
							CartJS.addItem(12074957766730, 1); //Free Rose Heart's Favorites (7 gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == '5blends') {
							CartJS.addItem(12074957832266, 1); //FREE Top 5 Diffuser Blends (5 Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'clean') {
							CartJS.addItem(12074957865034, 1); //FREE Clean House Kit (6 Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'mflash') {
							CartJS.addItem(12110393573450, 1); //Memorial Day Flash Sale! (12 FREE GIFTS)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'dad') {
							CartJS.addItem(12127264997450, 1); //Free Father's Day Gifts
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'jf18') {
							CartJS.addItem(12127270240330, 1); //July 4th FLASH SALE! (4 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lt18') {
							CartJS.addItem(12127276007498, 1); //FREE 2 Best Selling Gifts
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'goddess') {
							CartJS.addItem(12127281610826, 1); //FREE Inner Goddess Gifts (3 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'treat') {
							CartJS.addItem(12127284691018, 1); //FREE Self Care Bundle (3 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'summer') {
							CartJS.addItem(12127288361034, 1); //FREE Summer Paradise Gifts!
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'thanks') {
							CartJS.addItem(2931568803866, 1); //THANKSGIVING GIFTS: Free Chamomile Hydrosol & Pure Joy Blend
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'school') {
							CartJS.addItem(12374629384266, 1); //Back to School Gifts (2 Essential Oil Blends)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'schoolkit') {
							CartJS.addItem(12374638329930, 1); //Back to School Gifts (3 Essential Oil Blends + Diffuser)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'argan') {
							CartJS.addItem(12374640754762, 1); //Free Argan Lovers Trio
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'renew') {
							CartJS.addItem(2504392310810, 1);
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'fall18') {
							CartJS.addItem(12470765912138, 1); //Free Argan Lovers Trio
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lav8') {
							CartJS.addItem(12556439879754, 1); //FREE 8 oz Lavender Essential Oil
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lday') {
							CartJS.addItem(12569297649738, 1); //Labor Day Flash Sale (2 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lavcollection') {
							CartJS.addItem(12569301614666, 1); //Labor Day Flash Sale ( 5 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lav4') {
							CartJS.addItem(13613926940746, 1); //FREE 4 oz Lavender Essential Oil
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'beauty') {
							CartJS.addItem(13628784672842, 1); //FREE 4 oz Lavender Essential Oil
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'blends') {
							CartJS.addItem(13634652766282, 1); //FREE Blend Sampler Set (5 Free Blends)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'purekit') {
							CartJS.addItem(15387976663114, 1); //FREE Blend Sampler Set (5 Free Blends)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'argan99') {
							CartJS.addItem(15387977908298, 1); //FREE Blend Sampler Set (5 Free Blends)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'stockings') {
							CartJS.addItem(15394983149642, 1); //FREE Stocking Stuffers (4 Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'fmgifts') {
							CartJS.addItem(15859631325258, 1); //FREE Frankincense & Myrrh Gifts
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'rosehip75') {
							CartJS.addItem(16236971851850, 1); //FREE Rosehip Seed Oil (8 oz)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'chakras') {
							CartJS.addItem(28028019081290, 1); //FREE Chakra & Alignment Oils
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'rbundle') {
							CartJS.addItem(28266036461642, 1); //FREE Mother's Day Gifts (3 Free Gifts)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'mstarter') {
							CartJS.addItem(30172848848970, 1); //FREE Massage Oil Starter Kit
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == '4skin') {
							CartJS.addItem(30172864249930, 1); //Free Anti-Aging & Hydrating Oils
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'abundance') {
							CartJS.addItem(30172934373450, 1); //Free Abundance & Prosperity Oils
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lovefall') {
							CartJS.addItem(30882776776778, 1); //5 Free Gifts for Fall
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == '4rolls') {
							CartJS.addItem(31350705324106, 1); //Holiday Gifts: Four Free Roll-Ons
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'freehc') {
							CartJS.addItem(31350729506890, 1); //Free Holiday Delight Collection
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'fmbundle') {
							CartJS.addItem(31350799695946, 1); //Black Friday: FREE Frankincense (1 oz) and Myrrh (1 oz) Essential Oils
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'pms') {
							CartJS.addItem(31687693926474, 1); //Free PMS Relief Kit
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'vdaykit') {
							CartJS.addItem(31687695040586, 1); //Free Valentine's Day Collection!
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'healthy') {
							CartJS.addItem(31884970328138, 1); //*Free* Turmeric Essential Oil (1 oz) & Immune Protection Blend (1 oz)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'fm20') {
							CartJS.addItem(31884973604938, 1); //FREE Organic Frankincense Essential Oil (15 ml) AND Myrrh Essential Oil (15 ml)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'flash10') {
							CartJS.addItem(32483185918026, 1); //Bulk Flash Sale- 10 Free Gifts!
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lavjas') {
							CartJS.addItem(32518075744330, 1); //FREE Lavender Infused Massage Oil (32 oz) & Jasmine Infused Massage Oil (16 oz)
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'freehc') {
							CartJS.addItem(31350729506890, 1); //Free Holiday Delight Collection
							dismsg = '';
							success_message = "Your free product has been added to the cart.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'lav30') {
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'frank20') {
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						
						if(codeValue == 'bogo') {
        				    lookCode = '3261661282330';
        				    bogoPro = '3261651714074';
        				    checkBogo(lookCode, bogoPro);
        				} else
						
						if(codeValue == 'ep17') {
							CartJS.addItem(1966121156634, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'spe17') {
							CartJS.addItem(2057121169434, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'threegifts') {
							CartJS.addItem(2343970996250, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'akt50') {
							CartJS.addItem(2504281096218, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'renew') {
							CartJS.addItem(2504392310810, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						
						if(codeValue == 'tang10') {
							CartJS.addItem(2504452767770, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						
						if(codeValue == 'bt15') {
							CartJS.addItem(2504485765146, 1);
							success_message = " Discount will appear at checkout.";
							applyDiscountMsg(success_message,dismsg,codeValue);
						} else
						if(codeValue == 'freeship') {
    						dismsg = '';
    						success_message = "Free Shipping will be applied to qualified orders.";
    						applyDiscountMsg(success_message,dismsg,codeValue);
    					} else
						//ADD ITEMS TO CART
						if(hasVariant) {
						    console.log('has variant!!!');
							$.each(entitled_variant_ids, function(i, val) {
								//Shopify.addItem(entitled_variant_ids[i], 1);
								CartJS.addItem(entitled_variant_ids[i], 1);
								success_message = " Discount will appear at checkout.";
								applyDiscountMsg(success_message,dismsg,codeValue);
							});
						} else
						if(hasProduct) {
						    console.log('has product!!!');
							//$.each(entitled_product_ids, function(i, val) {
							    //checkIfProduct(codeValue, entitled_product_ids[i]);
							    checkIfProduct(codeValue, entitled_product_ids);
							//});
						} 
						else
						{
						    dismsg = '';
						    success_message = " Discount will appear at checkout.";
						    applyDiscountMsg(success_message,dismsg,codeValue);
						}
						//apply discount code
						function applyDiscountMsg(success_message,dismsg,codeValue) {
						    $('.coupon-error').css('display', 'none');
    						$('.coupon-success').css('display', 'block').text(success_message);
    						$('.coupon-success').prepend(dismsg);
    						$('.js-form-discount').val(codeValue);
						}
    				}
    				
    				function checkIfProduct(codeValue, productID) {
    				    var isPresent = false;
    				    console.log('productID='+productID);
    				    
                        $.getJSON('/cart.js', function(cart) {
                            $.each(cart.items, function(i, data) {
                                $.each(productID, function(k, val) {
            				        if(productID[k] == data.product_id) {
            				            isPresent = true;
            				        }
            				    });
                                console.log('cart item: '+ data.product_id);
                            });
                            console.log('isPresent = '+ isPresent);
                            checkIsTrue(codeValue, isPresent);
                            function checkIsTrue(codeValue, isPresent) {
                                if(isPresent == true) {
                                    success_message = " Discount will appear at checkout.";
                                    $('.coupon-error').css('display', 'none');
									$('.coupon-success').css('display', 'block').text(success_message);
            						$('.coupon-success').prepend(dismsg);
            						$('.js-form-discount').val(codeValue);
                                } else {
                                    dismsg = '';
                                    $('.coupon-success').css('display', 'none');
                                    error_message = "No qualifying product in cart.";
                                    $('.coupon-error').css('display', 'block').text(error_message).delay(4000).fadeOut();
                                }
                            }
                        });
    				}
    				
    				function checkBogo(lookCode, bogoPro) {
    				    var isPresent = false;
                        $.getJSON('/cart.js', function(cart) {
                            $.each(cart.items, function(i, data) {
                                //console.log('cart item: '+ data.variant_id);
                                if(data.variant_id == lookCode) {
                                    isPresent = true;
                                } 
                            });
                            checkIsPresent(isPresent);
                        });
                        
                        function checkIsPresent(isPresent) {
                            //console.log(isPresent);
                            if(isPresent == true) {
                                CartJS.addItem(bogoPro, 1);
                                dismsg = '';
                                success_message = "Qualifying product(s) have been added to cart.";
                                $('.coupon-success').css('display', 'block').text(success_message);
        						$('.coupon-success').prepend(dismsg);
        						$('.js-form-discount').val(codeValue);
                            } else if(isPresent == false) {
                                bogoPro = false;
                                dismsg = '';
                                console.log('no qualifying product found in cart.');
                                error_message = "No qualifying product in cart.";
                                $('.coupon-error').css('display', 'block').text(error_message).delay(4000).fadeOut();
                            }
                        }
    				}
    				
    				//CHECK FOR MINIMUM AMOUNT
    				if($.isEmptyObject(min)) {
    					//no minimum cart requirements, you can process this!
    					min_amount = false;
    					runValue(codeValue);
    				} else {
    					//cart does have a minimum requirement, so now let's check values
    					min_amount = min['greater_than_or_equal_to'];
    					//console.log('check cart total: '+cartTotalPrice);
    					//console.log('check minamount: '+min_amount);
    					if(cartTotalPrice >= min_amount) {
    					    runValue(codeValue);
    					} else {
    					    console.log('cart requirements not met.');
    						error_message = "Cart does not meet minimum requirements.";
    						$('.coupon-error').css('display', 'block').text(error_message).delay(4000).fadeOut();
    					}
    				}
				}
				
			} else {
			    console.log('no valid coupon code found');
				error_message = "You did not enter a valid coupon code.";
				$('.coupon-error').css('display', 'block').text(error_message).delay(4000).fadeOut();
			}
			
		}
	}

	//CART COUPON CODE UPDATER
	$('#couponcodeinput').on('keypress', function(e) {
	    var keyCode = (e.keyCode ? e.keyCode : e.which);  
        if (keyCode == 13) {
            e.preventDefault();
            console.log('enter fired');
            var cartGTotal = $(this).next().attr('data-carttotal');
    		var codeValue = $(this).val().toLowerCase();
    		//console.log(cartGTotal);
    		checkDiscount(codeValue, cartGTotal);
        }
	});
    //SHOPPING CART INPUT (not checkout)
	$('.getdatapromo').on('click', function(e) {
		e.preventDefault();
		var cartGTotal = $(this).attr('data-carttotal');
		var codeValue = $('#couponcodeinput').val().toLowerCase();
		//console.log(cartGTotal);
		checkDiscount(codeValue, cartGTotal);
	});
});